import React from 'react';

import ExportButton from 'components/Grid/ExportButton/ExportButton';

import useExportReminders from './useExportReminders';

const RemindersExportButton = () => {
  const { exportReminders, isExportPending } = useExportReminders();

  return (
    <ExportButton
      id="reminders-export"
      isContextMenuItem
      onClick={exportReminders}
      disabledMessage={
        isExportPending
          ? 'Please wait for previous download to complete'
          : undefined
      }
    />
  );
};

export default RemindersExportButton;
